import LOGO_LARGE from '@move-core/asset-catalog/images/ca/web/img-logo.svg';
import LOGO_LARGE_INVERSE from '@move-core/asset-catalog/images/ca/web/img-logo-inverse.svg';
import LOGO_SMALL from '@move-core/asset-catalog/images/ca/web/img-logo-small.svg';
import { LogoVariants } from '../types';

export const kijijiLogo: LogoVariants = {
  small: {
    source: LOGO_SMALL,
    width: 40,
    height: 32
  },
  large: {
    source: LOGO_LARGE,
    width: 110,
    height: 22
  },
  largeInverse: {
    source: LOGO_LARGE_INVERSE,
    width: 110,
    height: 22
  }
};
